// extracted by mini-css-extract-plugin
export var layoutContainer = "_bn-0";
export var layoutContainerNoRounding = "_bn-6";
export var layoutContainerOpen = "_bn-5";
export var layoutContainerResizing = "_bn-1";
export var mainContent = "_bn-2";
export var resizeDivider = "_bn-3";
export var slidePanel = "_bn-4";